export class Constante {
    static RESPUESTA_OK      = '00';
    static ERROR_99          = '99';

    //TITULOS
    static TITULO_APROBAR_DOCUMENTO = 'Aprobar Documento';
    static TITULO_FIRMAR_ASIGNAR_DOCUMENTO  = 'Firmar y Asignar Documento';
    static TITULO_DERIVAR_DOCUMENTO  = 'Derivar Documento';
    static TITULO_SOLO_FIRMAR_DOCUMENTO  = 'Firmar Documento';
    static TITULO_RECHAZAR_DOCUMENTO  = 'Rechazar Documento';
    static TITULO_CHANGE_PASS = 'Cambiar Contraseña';
    static TITULO_ALERTA_PASS = 'Alerta de Contraseña';
    static TITULO_IMAGEN_DOC ='Pre visualizacion de documento';

    //AUTORIZACION
    static USAR_PERMISOS  = true;
    static AUTHORISED     = '1';
    static NOT_AUTHORISED = '0';
    static MENU           = 'menu.';
    static OPCION         = 'opcion.'; 
    static TYPE_MENU      = "menu";
    static TYPE_OPCION    = "opcion";
    static TYPE_SERVICIO  = "servicio";

    //ARCHIVO DE MENSAJES
    static MESSAGE_FILE = 'message.json';

    //AUTENTICACION
    static PATH_LOGIN = 'login';
    static PATH_LOGOUT = 'logout';
    static PATH_DESCARGAR = 'descargar';
    static PATH_SERVICIO = 'Servicio';

    //NIVELES
    static NIVEL_ = '_N';
    static NIVEL = 'nivel_';
    static NIVEL_UNO = 'nivel_1';
    static NIVEL_DOS = 'nivel_2';
    static NIVEL_TRES = 'nivel_3';
    static NIVEL_CUATRO = 'nivel_4';
    static SIGUIENTE = 'S'; //Siguiente
    static DEVOLUCION = 'D'; //Devolución
    //ESTADOS
    static CREADO = 'Creado';
    static ACEPTADO = 'Aceptado';
    static ANULADO = 'Anulado';
    static RECHAZADO = 'Rechazado';
    static PENDIENTE = 'Pendiente';
    static FIRMADO = 'Firmado';
    static APROBADO = 'Aprobado';
    static PRE_RECHAZADO = 'Pre_Rechazado';

    //ACCIONES
    static ACCION_APROBAR ='Aprobar';
    static ACCION_FIRMAR = 'Firmar';
    static ACCION_RECHAZAR = 'Rechazar';

    //NIVEL FIRMA
    static CASO_NIVEL_FIRMA = '1,3,4';

}

